import * as r from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/ArrowSquareIn.es.js";
const o = r.forwardRef((e, a) => /* @__PURE__ */ r.createElement(t, { ref: a, ...e, weights: n }));
o.displayName = "ArrowSquareInIcon";
const s = o;
export {
  s as ArrowSquareIn,
  o as ArrowSquareInIcon
};
